'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _ComponentWithPartials = require('../mixins/ComponentWithPartials');

var _ComponentWithPartials2 = _interopRequireDefault(_ComponentWithPartials);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _OptionTypes = require('../types/OptionTypes');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactUtils = require('react-utils');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UITypeaheadUtils = require('./UITypeaheadUtils');

var _UITypeaheadResults = require('./results/UITypeaheadResults');

var _UITypeaheadResults2 = _interopRequireDefault(_UITypeaheadResults);

var _UITypeaheadResultsGroup = require('./results/UITypeaheadResultsGroup');

var _UITypeaheadResultsGroup2 = _interopRequireDefault(_UITypeaheadResultsGroup);

var _UITypeaheadResultsItem = require('./results/UITypeaheadResultsItem');

var _UITypeaheadResultsItem2 = _interopRequireDefault(_UITypeaheadResultsItem);

var _UITypeaheadSearch = require('./search/UITypeaheadSearch');

var _UITypeaheadSearch2 = _interopRequireDefault(_UITypeaheadSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function getFlattenedOptions(groupedOptions) {
  var groups = [];
  var options = [];

  groupedOptions.forEach(function (option) {
    if (option.hasOwnProperty('options')) {
      var groupIdx = groups.push(option) - 1;
      option.options.forEach(function (groupOption) {
        options.push(_extends({}, groupOption, {
          groupIdx: groupIdx
        }));
      });
    } else {
      options.push(_extends({}, option, {
        groupIdx: -1
      }));
    }
  });

  return { options: options, groups: groups };
}

function getHighlightedIndex(component, filtered) {
  return filtered.options.indexOf(component.getHighlighted(filtered));
}

var KeyHandlers = {
  ArrowDown: function ArrowDown(component) {
    var filtered = component.getFilteredOptions();
    var options = filtered.options;

    var nextIndex = (getHighlightedIndex(component, filtered) + 1) % options.length;
    component.setState({ highlighted: options[nextIndex] });
  },

  Enter: function Enter(component) {
    component.handleChange(component.getHighlighted(component.getFilteredOptions()));
  },

  ArrowUp: function ArrowUp(component) {
    var filtered = component.getFilteredOptions();
    var options = filtered.options;

    var index = getHighlightedIndex(component, filtered);
    var nextIndex = index === 0 ? options.length - 1 : index - 1;
    component.setState({ highlighted: options[nextIndex] });
  }
};

var UITypeahead = _react2.default.createClass({
  displayName: 'UITypeahead',

  mixins: [_reactAddonsPureRenderMixin2.default, _ComponentWithPartials2.default],

  propTypes: {
    autoFilter: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    hideResults: _react.PropTypes.bool,
    itemComponent: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
    minimumSearchCount: _react.PropTypes.number,
    onChange: _react.PropTypes.func,
    onSearchChange: _react.PropTypes.func,
    options: _react.PropTypes.arrayOf(_OptionTypes.OptionOrGroupType.isRequired).isRequired,
    placeholder: _react.PropTypes.string,
    resultsClassName: _react.PropTypes.string,
    search: _react.PropTypes.string,
    searchClassName: _react.PropTypes.string,
    style: _react.PropTypes.object,
    value: _OptionTypes.SingleValueType
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoFilter: true,
      hideResults: false,
      itemComponent: 'li',
      minimumSearchCount: 0,
      search: ''
    };
  },
  getInitialState: function getInitialState() {
    var _props = this.props,
        autoFilter = _props.autoFilter,
        options = _props.options,
        search = _props.search;

    return {
      flattened: getFlattenedOptions(options),
      highlighted: null,
      searchRegex: autoFilter ? (0, _UITypeaheadUtils.getSearchRegExp)(search) : undefined
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var options = _ref.options,
        search = _ref.search;

    if (!(0, _underscore.isEqual)(options, this.props.options)) {
      this.setState({ flattened: getFlattenedOptions(options) });
    }
    if (this.props.autoFilter && !(0, _underscore.isEqual)(search, this.props.search)) {
      this.setState({ searchRegex: (0, _UITypeaheadUtils.getSearchRegExp)(search) });
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    var highlightedNode = (0, _reactDom.findDOMNode)(this.refs.highlighted);
    if (!highlightedNode) {
      return;
    }
    var offsetHeight = highlightedNode.offsetHeight,
        offsetParent = highlightedNode.offsetParent,
        offsetTop = highlightedNode.offsetTop;

    var scrollTop = offsetParent.scrollTop;
    if (scrollTop > offsetTop) {
      offsetParent.scrollTop = offsetTop;
    }
    var nodeBottom = offsetHeight + offsetTop;
    var parentBottom = scrollTop + offsetParent.offsetHeight;
    if (parentBottom >= nodeBottom) {
      return;
    }
    offsetParent.scrollTop = scrollTop + nodeBottom - parentBottom;
  },
  focus: function focus() {
    if (this._searchRef) {
      this._searchRef.focus();
    }
  },
  getClassName: function getClassName() {
    return (0, _reactUtils.classNames)('private-dropdown', 'private-typeahead', { 'hide-search': this.getSearchCount() < this.props.minimumSearchCount }, this.props.className);
  },
  getFilteredOptions: function getFilteredOptions() {
    var _state = this.state,
        searchRegex = _state.searchRegex,
        flattened = _state.flattened;

    var results = searchRegex ? flattened.options.filter(function (_ref2) {
      var dropdownText = _ref2.dropdownText,
          text = _ref2.text,
          value = _ref2.value;
      return searchRegex.test(text) || searchRegex.test('' + value) || typeof dropdownText === 'string' && searchRegex.test(dropdownText);
    }) : flattened.options;

    return {
      groups: flattened.groups,
      options: results.length ? results : [(0, _UITypeaheadUtils.getNoMatchesOption)()]
    };
  },
  getHighlighted: function getHighlighted(filtered) {
    var value = this.props.value;
    var highlighted = this.state.highlighted;

    if (highlighted && filtered.options.indexOf(highlighted) > -1) {
      return highlighted;
    }
    return (0, _underscore.findWhere)(filtered.options, { value: value }) || filtered.options[0] || null;
  },
  getSearchCount: function getSearchCount() {
    var flattened = this.state.flattened;

    if (!flattened || !flattened.options) {
      return -1;
    }
    return flattened.options.length + flattened.groups.length;
  },
  handleChange: function handleChange(option, evt) {
    if (option.disabled) {
      return;
    }
    this.handleHighlight(option);
    var onChange = this.props.onChange;

    onChange((0, _SyntheticEvent2.default)(option.value, evt));
  },
  handleHighlight: function handleHighlight(option) {
    var highlighted = this.state.highlighted;

    if (highlighted === option) {
      return;
    }
    this.setState({ highlighted: option });
  },
  handleKeyDown: function handleKeyDown(evt) {
    if (KeyHandlers.hasOwnProperty(evt.key)) {
      evt.preventDefault();
      KeyHandlers[evt.key](this, evt);
    }
  },
  searchRefCallback: function searchRefCallback(ref) {
    this._searchRef = ref;
  },
  renderFilteredOptions: function renderFilteredOptions() {
    var _this = this;

    var filtered = this.getFilteredOptions();
    var groups = filtered.groups;

    var highlighted = this.getHighlighted(filtered);
    var groupIdx = -1;
    var groupedOptions = [];
    var options = [];

    filtered.options.forEach(function (option) {
      if (option.groupIdx !== groupIdx) {
        if (groupedOptions.length) {
          options.push(_this.renderResultsGroup(groups[groupIdx], groupedOptions, highlighted));
        }
        groupIdx = option.groupIdx;
        groupedOptions = [];
      }

      if (option.groupIdx === -1) {
        options.push(_this.renderResultsItem(option, highlighted));
      } else {
        groupedOptions.push(option);
      }
    });

    if (groupedOptions.length) {
      options.push(this.renderResultsGroup(groups[groupIdx], groupedOptions, highlighted));
    }

    return options;
  },
  renderResults: function renderResults(_ref3) {
    var hideResults = _ref3.hideResults,
        resultsClassName = _ref3.resultsClassName;

    if (hideResults) {
      return null;
    }
    return _react2.default.createElement(
      _UITypeaheadResults2.default,
      { className: resultsClassName },
      this.renderFilteredOptions()
    );
  },
  renderResultsGroup: function renderResultsGroup(group, options, highlighted) {
    var _this2 = this;

    return _react2.default.createElement(
      _UITypeaheadResultsGroup2.default,
      {
        group: group,
        key: group.value || group.options[0].value
      },
      options.map(function (option) {
        return _this2.renderResultsItem(option, highlighted);
      })
    );
  },
  renderResultsItem: function renderResultsItem(option, highlighted) {
    if (option === (0, _UITypeaheadUtils.getNoMatchesOption)()) {
      return this.renderResultsEmpty();
    }
    var isHighlighted = highlighted === option;
    return _react2.default.createElement(_UITypeaheadResultsItem2.default, {
      highlighted: isHighlighted,
      itemComponent: this.props.itemComponent,
      key: option.value,
      onClick: this.partial(this.handleChange, option),
      onMouseEnter: this.partial(this.handleHighlight, option),
      option: option,
      ref: isHighlighted ? 'highlighted' : null,
      search: this.state.searchRegex
    });
  },
  renderResultsEmpty: function renderResultsEmpty() {
    return _react2.default.createElement(_UITypeaheadResultsItem2.default, {
      disabled: true,
      itemComponent: this.props.itemComponent,
      key: (0, _UITypeaheadUtils.getNoMatchesOption)().value,
      option: (0, _UITypeaheadUtils.getNoMatchesOption)()
    });
  },
  renderSearch: function renderSearch(_ref4) {
    var onSearchChange = _ref4.onSearchChange,
        search = _ref4.search,
        searchClassName = _ref4.searchClassName,
        rest = _objectWithoutProperties(_ref4, ['onSearchChange', 'search', 'searchClassName']);

    return _react2.default.createElement(_UITypeaheadSearch2.default, _extends({}, rest, {
      className: searchClassName,
      onChange: onSearchChange,
      onKeyDown: this.handleKeyDown,
      value: search,
      ref: this.searchRefCallback
    }));
  },
  render: function render() {
    var _props2 = this.props,
        __autoFilter = _props2.autoFilter,
        hideResults = _props2.hideResults,
        __itemComponent = _props2.itemComponent,
        __minimumSearchCount = _props2.minimumSearchCount,
        onSearchChange = _props2.onSearchChange,
        __options = _props2.options,
        resultsClassName = _props2.resultsClassName,
        search = _props2.search,
        searchClassName = _props2.searchClassName,
        style = _props2.style,
        rest = _objectWithoutProperties(_props2, ['autoFilter', 'hideResults', 'itemComponent', 'minimumSearchCount', 'onSearchChange', 'options', 'resultsClassName', 'search', 'searchClassName', 'style']);

    var renderedSearch = this.renderSearch(_extends({
      onSearchChange: onSearchChange,
      search: search,
      searchClassName: searchClassName
    }, rest));

    return _react2.default.createElement(
      'div',
      { className: this.getClassName(), style: style },
      renderedSearch,
      this.renderResults({ hideResults: hideResults, resultsClassName: resultsClassName })
    );
  }
});

var ControllableTypeahead = (0, _Controllable2.default)(UITypeahead, ['search', 'value']);

ControllableTypeahead.noMatchesI18nKey = 'salesUI.UITypeahead.noMatchesFound';
ControllableTypeahead.noOptionsI18nKey = 'salesUI.UITypeahead.noOptions';

exports.default = ControllableTypeahead;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/typeahead/UITypeahead.js
// module id = 300
// module chunks = 0